import React, { Component } from 'react';
import "./Footer.scss";

export default class Footer extends Component {
  render() {
    return (
      //   <div className="section-header">
      //   <div className="container">
      //     <div className="row">
      //       <div className="col-12">
      //         <h1 className="big-title">Calculadora de Mantenimiento</h1>
      //         <h2 id="header-calcula-el-coste"className="medium-title">Calcula el coste de las operaciones de mantenimiento de tu Lexus</h2>
      //       </div>
      //     </div>
      //   </div>
      // </div>
      <div _ngcontent-c0="" class="l-container" style={{ paddingTop: "1rem", paddingBottom: ".625rem" }}>
        <div _ngcontent-c0="" class="l-row">
          <div _ngcontent-c0="" class="l-col--xsmall-12 l-col--medium">
            <div _ngcontent-c0="" class="c-region">
              <a _ngcontent-c0="" class="c-country-language-selector__countries c-country-language-selector__countries--es" href="https://www.lexusauto.es/forms/country-selector" target="_self">España – Español</a>
            </div>
          </div>
          <div _ngcontent-c0="" class="l-col--xsmall-12 l-col--medium-0">
            <nav _ngcontent-c0="" aria-label="Legal" class="c-legal-nav" role="navigation">
              <ul _ngcontent-c0="" class="c-legal-nav__menu"></ul>
            </nav>
          </div>
          <div _ngcontent-c0="" class="l-col--xsmall-12 l-col--medium-0">
            <div _ngcontent-c0="" class="c-copyright">
              <span _ngcontent-c0="" class="c-copyright__inner" style={{ fontSize: ".75rem" }}>© 2024 </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
